import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { PageHeader } from '../components/PageHeader';
import { OrganogramSection } from '../components/OrganogramSection';
import { Award, Shield, FileCheck } from 'lucide-react';
export function StructurePage() {
  return <div className="font-sans bg-warm-ivory min-h-screen w-full" data-id="element-760">
      <Header data-id="element-761" />
      <main className="w-full font-sans" data-id="element-762">
        <PageHeader title="Organizational Structure" subtitle="Meet the team behind our mission and understand how we operate" badgeText="OUR STRUCTURE" bgColor="bg-gradient-to-r from-sfrr-blue to-sfrr-green" data-id="element-763" />

        {/* Founder Profile Section */}
        <section className="py-16 bg-white" data-id="element-764">
          <div className="container mx-auto px-4" data-id="element-765">
            <div className="max-w-5xl mx-auto" data-id="element-766">
              <div className="text-center mb-12" data-id="element-767">
                <span className="inline-block px-4 py-1.5 rounded-full bg-sfrr-pink/10 text-sfrr-pink text-sm font-semibold mb-4" data-id="element-768">
                  Foundation Leadership
                </span>
                <h2 className="text-3xl md:text-4xl font-serif font-bold text-charcoal mb-4" data-id="element-769">
                  Led by Vision & Experience
                </h2>
              </div>

              <div className="bg-gradient-to-br from-warm-ivory to-white rounded-3xl shadow-xl overflow-hidden" data-id="element-770">
                <div className="grid grid-cols-1 lg:grid-cols-5 gap-0" data-id="element-771">
                  {/* Image Column */}
                  <div className="lg:col-span-2 relative" data-id="element-772">
                    <div className="absolute inset-0 bg-gradient-to-br from-sfrr-pink/10 to-sfrr-blue/10" data-id="element-773" />
                    <img src="https://cdn.magicpatterns.com/uploads/bbEknxtjSFBKULaAfMFH6V/674f1612-c4d6-4931-84d9-dd37fd86f516.jpg" alt="Senator Fatimat Raji Rasaki - Founder & President" className="w-full h-full min-h-[400px] lg:min-h-[500px] object-cover object-center" data-id="element-774" />
                  </div>

                  {/* Content Column */}
                  <div className="lg:col-span-3 p-8 md:p-12" data-id="element-775">
                    <div className="flex items-center gap-3 mb-6" data-id="element-776">
                      <div className="w-12 h-12 rounded-full bg-sfrr-pink/10 flex items-center justify-center" data-id="element-777">
                        <Award className="w-6 h-6 text-sfrr-pink" data-id="element-778" />
                      </div>
                      <div data-id="element-779">
                        <p className="text-sm text-gray-500 uppercase tracking-wide font-medium" data-id="element-780">
                          Founder & President
                        </p>
                      </div>
                    </div>

                    <h3 className="text-3xl md:text-4xl font-serif font-bold text-charcoal mb-4" data-id="element-781">
                      Senator Fatimat Raji Rasaki
                    </h3>

                    <p className="text-gray-600 leading-relaxed mb-6" data-id="element-782">
                      As Founder and President of the SFRR Foundation, Senator
                      Fatimat Raji Rasaki serves as the custodian of the
                      Foundation's vision, legacy, and long-term direction. Her
                      decades of public service and legislative experience
                      inform the Foundation's strategic approach to community
                      development and social impact.
                    </p>

                    <div className="space-y-4 mb-8" data-id="element-783">
                      <div className="flex items-start gap-3" data-id="element-784">
                        <div className="w-6 h-6 rounded-full bg-sfrr-green/20 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-785">
                          <div className="w-2 h-2 rounded-full bg-sfrr-green" data-id="element-786" />
                        </div>
                        <p className="text-sm text-gray-600" data-id="element-787">
                          <span className="font-semibold text-charcoal" data-id="element-788">
                            Former Senator:
                          </span>{' '}
                          Extensive legislative and policy experience
                        </p>
                      </div>
                      <div className="flex items-start gap-3" data-id="element-789">
                        <div className="w-6 h-6 rounded-full bg-sfrr-blue/20 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-790">
                          <div className="w-2 h-2 rounded-full bg-sfrr-blue" data-id="element-791" />
                        </div>
                        <p className="text-sm text-gray-600" data-id="element-792">
                          <span className="font-semibold text-charcoal" data-id="element-793">
                            Community Advocate:
                          </span>{' '}
                          Decades of grassroots engagement
                        </p>
                      </div>
                      <div className="flex items-start gap-3" data-id="element-794">
                        <div className="w-6 h-6 rounded-full bg-sfrr-pink/20 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-795">
                          <div className="w-2 h-2 rounded-full bg-sfrr-pink" data-id="element-796" />
                        </div>
                        <p className="text-sm text-gray-600" data-id="element-797">
                          <span className="font-semibold text-charcoal" data-id="element-798">
                            Visionary Leader:
                          </span>{' '}
                          At 70, dedicating her next chapter to structured
                          service
                        </p>
                      </div>
                    </div>

                    <div className="pt-6 border-t border-gray-200" data-id="element-799">
                      <p className="text-sm text-gray-500 italic" data-id="element-800">
                        "My commitment is to ensure every Nigerian has access to
                        opportunities that enable them to move from
                        vulnerability to dignity and self-reliance."
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <OrganogramSection data-id="element-801" />

        {/* Governance Section */}
        <section className="py-16 bg-white" data-id="element-802">
          <div className="container mx-auto px-4" data-id="element-803">
            <div className="max-w-4xl mx-auto" data-id="element-804">
              <div className="text-center mb-12" data-id="element-805">
                <span className="inline-block px-4 py-1.5 rounded-full bg-sfrr-blue/10 text-sfrr-blue text-sm font-semibold mb-4" data-id="element-806">
                  Governance Framework
                </span>
                <h2 className="text-3xl md:text-4xl font-serif font-bold text-charcoal mb-4" data-id="element-807">
                  Built on Transparency & Accountability
                </h2>
                <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-808">
                  Our governance structure ensures ethical operations, financial
                  integrity, and maximum impact.
                </p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12" data-id="element-809">
                {[{
                icon: <Shield className="w-8 h-8" data-id="element-810" />,
                title: 'Transparent Leadership',
                description: 'Clear governance structure with defined roles and accountability',
                color: 'bg-sfrr-green'
              }, {
                icon: <FileCheck className="w-8 h-8" data-id="element-811" />,
                title: 'Financial Oversight',
                description: 'Regular audits and transparent financial reporting',
                color: 'bg-sfrr-pink'
              }, {
                icon: <Award className="w-8 h-8" data-id="element-812" />,
                title: 'Ethical Standards',
                description: 'Strict code of ethics guiding all operations',
                color: 'bg-sfrr-blue'
              }].map((item, index) => <div key={index} className="bg-warm-ivory rounded-2xl p-6 shadow-soft hover:shadow-hover transition-all duration-300 hover:-translate-y-1" data-id="element-813">
                    <div className={`w-14 h-14 rounded-xl ${item.color} bg-opacity-10 flex items-center justify-center mb-4`} data-id="element-814">
                      <div className={`${item.color.replace('bg-', 'text-')}`} data-id="element-815">
                        {item.icon}
                      </div>
                    </div>
                    <h3 className="text-xl font-bold text-charcoal mb-2" data-id="element-816">
                      {item.title}
                    </h3>
                    <p className="text-gray-600 text-sm leading-relaxed" data-id="element-817">
                      {item.description}
                    </p>
                  </div>)}
              </div>

              <div className="space-y-6" data-id="element-818">
                <div className="bg-white rounded-2xl p-8 shadow-soft border border-gray-100" data-id="element-819">
                  <h3 className="text-xl font-bold text-sfrr-green mb-4 flex items-center gap-3" data-id="element-820">
                    <Shield className="w-6 h-6" data-id="element-821" />
                    Transparent Leadership
                  </h3>
                  <p className="text-gray-600 leading-relaxed" data-id="element-822">
                    Our foundation operates under a clear governance structure
                    that ensures transparency, accountability, and efficient
                    decision-making. The Board of Trustees provides strategic
                    direction while the Executive Committee manages day-to-day
                    operations.
                  </p>
                </div>

                <div className="bg-white rounded-2xl p-8 shadow-soft border border-gray-100" data-id="element-823">
                  <h3 className="text-xl font-bold text-sfrr-pink mb-4 flex items-center gap-3" data-id="element-824">
                    <FileCheck className="w-6 h-6" data-id="element-825" />
                    Financial Oversight
                  </h3>
                  <p className="text-gray-600 leading-relaxed" data-id="element-826">
                    We maintain strict financial controls and undergo regular
                    audits to ensure donor funds are used effectively and
                    efficiently. Our financial reports are available to
                    stakeholders to maintain transparency in our operations.
                  </p>
                </div>

                <div className="bg-white rounded-2xl p-8 shadow-soft border border-gray-100" data-id="element-827">
                  <h3 className="text-xl font-bold text-sfrr-blue mb-4 flex items-center gap-3" data-id="element-828">
                    <Award className="w-6 h-6" data-id="element-829" />
                    Ethical Standards
                  </h3>
                  <p className="text-gray-600 leading-relaxed" data-id="element-830">
                    All members of our organization adhere to a strict code of
                    ethics that guides our work and interactions with
                    beneficiaries, donors, and partners. We are committed to
                    maintaining the highest standards of integrity in all our
                    activities.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer data-id="element-831" />
    </div>;
}